"use client";

import React from "react";
import { Phone, Mail } from "lucide-react";

const contacts = [
  {
    icon: <Phone className="w-5 h-5 text-[#0B6EA8]" />,
    text: "+91 9031 200 225 ",
    href: "tel:+919031200225 ",
  },
  {
    icon: <Phone className="w-5 h-5 text-[#0B6EA8]" />,
    text: "+91 9031 200 226",
    href: "tel:+919031200226",
  },
  {
    icon: <Mail className="w-5 h-5 text-[#0B6EA8]" />,
    text: "placement@msu.edu.in",
    href: "mailto:placement@msu.edu.in",
  },
];

export default function PlacementContactSection() {
  return (
    <section className="page-container mx-auto pb-8 md:pb-16">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
        {contacts.map((contact, index) => (
          <a
            key={index}
            href={contact.href}
            className="group relative flex items-center gap-5 bg-white border border-gray-100 p-6 rounded-2xl shadow-[0_4px_20px_-4px_rgba(0,0,0,0.1)] transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_20px_40px_-12px_rgba(0,119,181,0.15)] hover:border-[#0077B5]/30"
          >
            {/* Icon Container */}
            <div className="flex items-center justify-center w-14 h-14 bg-[#0077B5]/10 rounded-xl shrink-0 transition-colors duration-300 group-hover:bg-[#0077B5]">
              {React.cloneElement(contact.icon, {
                className:
                  "w-6 h-6 text-[#0077B5] transition-colors duration-300 group-hover:text-white",
              })}
            </div>

            {/* Text Content */}
            <div className="flex flex-col min-w-0">
              <span className="text-xs font-bold uppercase tracking-wider text-gray-400 mb-1 group-hover:text-[#0077B5] transition-colors">
                {contact.href.startsWith("mailto") ? "Email Us" : "Call Us"}
              </span>
              <span
                className="text-base sm:text-lg lg:text-xl font-bold text-gray-800 group-hover:text-[#0077B5] transition-colors break-words"
                style={{ fontFamily: "saans-bold" }}
              >
                {contact.text}
              </span>
            </div>

            {/* Subtle Arrow Decor */}
            <div className="absolute right-6 opacity-0 -translate-x-2 transition-all duration-300 group-hover:opacity-100 group-hover:translate-x-0">
              <svg
                className="w-5 h-5 text-[#0077B5]"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2.5}
                  d="M17 8l4 4m0 0l-4 4m4-4H3"
                />
              </svg>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}
